export default {
  downloadBanner: {
    title: "Установите веб-приложение RC CITY на смартфон",
    description:
      "Выберите способ установки и пользуйтесь сервисом с телефона, как обычным мобильным приложением",
    iosButton: "Для iOS",
    androidButton: "Для Android",
    imageAlt: "Телефон с приложением",
  },
  applicationAdvantages: {
    title:
      "Веб-приложение RC CITY – это оптимальное сочетание основных преимуществ веб-сайта и мобильного приложения",
    advantages: {
      0: {
        title: "Установка на экран",
        description:
          "Быстрый и удобный доступ ко всему функционалу сайта с домашнего экрана вашего устройства.",
      },
      1: {
        title: "Весит менее 1 Мб",
        description:
          "Экономит память вашего устройства и имеет меньшие требования к его производительности.",
      },
      2: {
        title: "Полный экран",
        description:
          "Открывается без адресной строки и других элементов браузера, адаптируется под любые устройства.",
      },
      3: {
        title: "Обновляется при запуске",
        description:
          "Не нужно проверять наличие обновлений и скачивать последнюю версию в Google Play или App Store.",
      },
      4: {
        title: "Быстрая загрузка",
        description:
          "С начала загрузки до отображения первого элемента обычно проходит не более 1 секунды.",
      },
      5: {
        title: "Доступность оффлайн",
        description:
          "Может кэшировать определённую информацию и отображать ее даже без доступа к интернету.",
      },
      6: {
        title: "Фоновый режим",
        description:
          "Для синхронизации данных или получения push-уведомлений нет необходимости держать приложение открытым.",
      },
      7: {
        title: "Плавная анимация",
        description:
          "Работает быстро как нативное мобильное приложение с мгновенным откликом и плавной анимацией.",
      },
      8: {
        title: "Экономия энергии",
        description:
          "Потребляет малое количество энергии, что позволяет экономить заряд батареи, продлевая время работы.",
      },
    },
  },

  instructionIOS: {
    title: "Как установить веб-приложение RC CITY на iOS",
    steps: {
      first: {
        text: "Откройте сайт <a href='https://rc.city/' target='_blank'>rc.city</a> с телефона в браузере Safari и нажмите на&nbsp;иконку «Поделиться».",
      },
      second: {
        text: "В открывшемся окне прокрутите вниз и в меню опций выберите «На экран Домой».",
      },
      third: {
        text: "В правом верхнем углу нажмите «Добавить» — иконка RC CITY появится на экране «Домой».",
      },
    },
  },

  instructionAndroid: {
    title: "Как установить веб-приложение RC CITY на Android",
    description: {
      part1: "C телефона нажмите",
      installButton: "«Установить на Android»",
      part2: "или выполните следующие действия в браузере в ручном режиме.",
    },
    steps: {
      first: {
        text: "Откройте сайт <a href='https://rc.city/' target='_blank'>rc.city</a> в браузере с телефона и в правом верхнем углу нажмите на иконку «Еще».",
      },
      second: {
        text: "В открывшемся боковом меню прокрутите вниз и выберите «Добавить на гл. экран».",
      },
      third: {
        text: "В модальном окне нажмите «Установить» — иконка RC CITY появится на главном экране.",
      },
    },
  },
  pwaHelp: {
    title: "Возникли сложности с установкой?",
    description:
      'Обратитесь в службу технической поддержки в <a href="https://t.me/rccity" target="_blank">Telegram</a> или по эл. почте <a href="mailto:hello&#64;rc.city" target="_blank">hello&#64;rc.city</a>',
  },
};
